module.exports = __webpack_public_path__ + "static/gomux-9afa6b3b95f1a48d4f2f96d8ab944b60.jpeg";